import ScrollToTop from 'feature/scrollToTop/ScrollToTop'
import CheckIsApiVariableExist from 'helpers/checkIsApiVariableExist'
import { Footer, Header } from 'layouts'
import { ErrorHandlerLayout } from 'layouts/ErrorHandlerLayout'
import React, { useEffect } from 'react'
import { Notifications } from 'widget/Notifications'

import style from './MainLayout.module.scss'
import { isLkmDomain } from 'router/utils'

type PropsType = {
  children: React.ReactNode
}

// главный Layout для всех страниц сайта
export function MainLayout({ children }: PropsType) {
  const isLkm = isLkmDomain()

  useEffect(() => {
    if (isLkm) {
      if (!document.body.classList.contains('lkmTheme')) {
        document.body.classList.add('lkmTheme')
      }
    } else {
      document.body.classList.remove('lkmTheme')
    }
  }, [isLkm])

  return (
    <ErrorHandlerLayout>
      <div className={style.container}>
        <Header />
        <div className={style.content}>
          {children}
          <Notifications />
          <ScrollToTop />
          <CheckIsApiVariableExist />
        </div>
        <Footer className={style.footer} />
      </div>
    </ErrorHandlerLayout>
  )
}
